module.exports = __webpack_public_path__ + "static/img/3.b71ae4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mgaofu/3.png
// module id = QQRn
// module chunks = 0